import React, { useState } from "react"
import { makeStyles } from "@material-ui/core/styles"
//import Typography from '@material-ui/core/Typography';
import { Grid, Typography } from "@material-ui/core"
import LabelValue from "./LabelValue"

const useStyles = makeStyles((theme) => ({
	metaSection: {
		backgroundColor: theme.palette.common.white,
		//color: theme.palette.grey[800],
		//color: "#7A869A",
		padding: theme.spacing(6, 2),
		border: "1px solid rgba(44, 53, 51, 0.12)",
		borderRadius: "3px",
	},
}))

const MetadataSection = (props) => {
	const classes = useStyles()

	// Default layout
	// const metaData = [
	//     {
	//         label: 'Case name',
	//         value: 'NER',
	//     },
	//     {
	//         label: 'Case created date',
	//         value: '18 dec 2022',
	//     },
	//     {
	//         label: 'Case description',
	//         value: 'Lorem ipsum dolor sit amet consectetur. Eget ut vestibulum semper feugiat posuere senectus. Id sodales velit sit dui nulla viverra sit mi. Viverra tempus eleifend morbi aenean elit tempus nibh.',
	//     },
	//     {
	//         label: 'Case created by',
	//         value: 'User name',
	//     }
	// ];
	// const dataRows = (metaData) => {
	//     const element = metaData.map((data, i) => {
	//     return (
	//         <Grid key={i} item xs={6}>
	//             <LabelValue label={data.label} value={data.value}/>
	//         </Grid>
	//         )});
	//     return element;
	// }
	return (
		<Grid
			container
			item
			xs={12}
			//   spacing={3}
			className={classes.metaSection}
			justifyContent="space-around"
		>
			{props.children}
			{/* {dataRows(metaData)} */}
		</Grid>
	)
}

export default MetadataSection
